import React, { useState } from "react";
import WrapperInput, { IWrapperInput } from "./WrapperInput";
import { IconButton, TextField, TextFieldProps } from "@mui/material";
import { FieldValues, UseFormRegister } from "react-hook-form";
import { FiEye, FiEyeOff } from "react-icons/fi";

interface IPasswordInput extends Omit<IWrapperInput, "children"> {
  placeholder?: string;
  multiline?: boolean;
  errorMessage?: string | undefined;
  name?: TextFieldProps["name"];
  value?: TextFieldProps["value"];
  disabled?: boolean;
  readOnly?: boolean;
  onChange?: TextFieldProps["onChange"];
  register?: UseFormRegister<FieldValues> | undefined;
}

const heights = {
  input: "45px",
};

function PasswordInput({
  label,
  labelWidth = "20%",
  id,
  placeholder,
  required,
  errorMessage,
  name,
  value,
  disabled,
  readOnly,
  onChange,
  register,
  ...wrapperProps
}: IPasswordInput) {
  const [isPassword, setIsPassword] = useState<boolean>(true);

  return (
    <WrapperInput
      id={id}
      label={label}
      required={required}
      labelWidth={labelWidth}
      {...wrapperProps}
    >
      <TextField
        id={id}
        type={isPassword ? "password" : "text"}
        name={name}
        fullWidth
        placeholder={placeholder}
        autoComplete="off"
        spellCheck={false}
        helperText={errorMessage}
        value={value}
        onChange={onChange}
        slotProps={{
          input: {
            readOnly,
            disabled,
            endAdornment: (
              <IconButton onClick={() => setIsPassword(!isPassword)}>
                {isPassword ? <FiEyeOff size={16} /> : <FiEye size={16} />}
              </IconButton>
            ),
          },
        }}
        {...(name ? register?.(name) : {})}
        sx={{
          "& .MuiFormHelperText-root": {
            color: "error.main",
            fontStyle: "italic",
          },
          "& .MuiInputBase-root": {
            height: heights.input,
            px: 0,
            py: 0,
            border: "2px solid",
            borderColor: !!errorMessage ? "error.main" : "divider",
            "&:focus-within": {
              borderColor: !!errorMessage ? "error.main" : "primary.main",
            },
            "& .MuiInputBase-input": {
              height: heights.input,
              px: 2,
              py: 1,
            },
            "& fieldset": { border: "none" },
          },
        }}
      />
    </WrapperInput>
  );
}

export default PasswordInput;
